import { AUTH_TOKEN, COOKIE_AUTH_DETAILS, pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { getCookie } from 'globalservices/cookie';
import { hasEnabledFeature, isCRMImport } from 'globalutils/fmUtils';
import React, { lazy, useState } from 'react';
import { Link as LinkDom } from 'react-router-dom';
import { toggleVisibility } from './utils';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Export = lazy(() => import(`globalcomponents/UI/Export/${layout}`));
const Import = lazy(() => import(`globalcomponents/UI/Import/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));

const TopActions = ({
  history,
  vehicles,
  callback,
  filterBoth,
  handleExportVehicle,
  handleExportTrailer,
  handleImportVehiclePost,
  handleImportTrailerPost,
  Styled,
  i18n,
  logBook,
  setPagination,
  filters,
}) => {
  const beBaseUrl = window?.$environment?.BE_BASE_URL;
  const [openModal, setOpenModal] = useState(false);
  const [openModalRefImport, setModalRefImport] = useState(false);
  const [ModalListObjectImport] = useState({
    header: '',
    content: () => {},
  });
  const [ModalListObjectTemplate] = useState({
    header: '',
    content: () => {},
  });
  const [ModalListObject] = useState({
    header: '',
    content: () => {},
  });
  const [openModalRefTemplate, setModalRefTemplate] = useState(false);

  const exportTrailer = () => {
    handleExportTrailer({
      apiId: 'exportTrailer',
      callback: callback,
    });
  };
  const exportVehicle = () => {
    handleExportVehicle({
      apiId: 'exportVehicle',
      callback: callback,
    });
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const closeModalImport = () => {
    setModalRefImport(false);
  };

  const closeModalTemplate = () => {
    setModalRefTemplate(false);
    toggleVisibility('importItems');
  };

  const selectChange = (e) => {
    filterBoth(e);
    setPagination(true);
  };

  const importVehicles = (file) => {
    handleImportVehiclePost({
      data: file,
      apiId: 'importVehiclePost',
      callback: callback,
    });
    closeModalImport();
    if (document.getElementById('fileSelectimportVeh')) document.getElementById('fileSelectimportVeh').value = '';
  };

  const importTrailers = (file) => {
    handleImportTrailerPost({
      data: file,
      apiId: 'importTrailerPost',
      callback: callback,
    });
    closeModalImport();
    if (document.getElementById('fileSelectimportTra')) document.getElementById('fileSelectimportTra').value = '';
  };

  return (
    <Styled.TopWrapper>
      <Styled.SearchWrapper>
        <Search
          onChange={(e) => selectChange(e)}
          default={{
            vehicleFilteredList: vehicles.vehicleList,
            trailerFilteredList: vehicles?.trailerList,
          }}
          fromData
          placeHolder={i18n.t('vehicles.searchVehicleTrailer')}
          query={['unit_id', 'vin', 'driverNames', 'manufact']}
          id="searchVehicle"
        ></Search>
      </Styled.SearchWrapper>
      <Styled.ImpExpWrapper>
        <div className="addNew">
          <Button
            component={LinkDom}
            variant="body2"
            className="linkStyle"
            to={pageUrls.addVehicle}
            onClick={() => {
              history.push(pageUrls.addVehicle);
              closeModal();
            }}
            label={i18n.t('vehicles.addVehicle')}
          ></Button>
          <div className="importWrap">
            <div className="columnSection">
              <div className="importsection">
                <Import onClick={(e) => importVehicles(e)} asBinary importVehicle={i18n.t('vehicles.importVeh')} id="importVeh" />
              </div>
              <Link
                variant="body2"
                onClick={() => {
                  let url = beBaseUrl + '/vehicle/csvtemplate' + '?token=' + logBook?.documentToken;
                  let filename = 'Vehicle_import_template.csv';
                  if (isCRMImport()) {
                    filename = 'Vehicle_mini_import_template.csv';
                  }
                  if (!isCRMImport() && hasEnabledFeature('cameraIntegrationEnabled')) {
                    filename = 'Camera_Integrated_Import_Data_vehicle.csv';
                  }
                  const iframe = document.getElementById('importVehicleTemplateFrame');
                  const token = getCookie(COOKIE_AUTH_DETAILS)[AUTH_TOKEN];
                  iframe.contentWindow
                    .fetch(url, {
                      headers: {
                        Authorization: 'Bearer ' + token,
                      },
                    })
                    .then((response) => {
                      if (response.ok) {
                        response.blob().then((blob) => {
                          let url = window.URL.createObjectURL(blob);
                          let a = document.createElement('a');
                          a.href = url;
                          a.download = filename;
                          a.click();
                        });
                      } else {
                        console.log('Error: ' + response.status);
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                  closeModalTemplate();
                }}
              >
                <Icon src={mediaUrls?.excel} tooltip={i18n.t('vehicles.importVehicleTemplate')} />
              </Link>
            </div>
            <Export
              src={layout === 'NewUi' ? mediaUrls.new_export_circle : mediaUrls.new_export}
              filename={i18n.t('vehicles.exportVehicle')}
              toolTip={i18n.t('vehicles.exportVehicle')}
              buttonName={i18n.t('vehicles.exportVehicle')}
              className="exportContainer"
              onClick={() => exportVehicle()}
            />
            <Export
              src={layout === 'NewUi' ? mediaUrls.new_export_circle : mediaUrls.new_export}
              filename={i18n.t('vehicles.exportTrailer')}
              toolTip={i18n.t('vehicles.exportTrailer')}
              buttonName={i18n.t('vehicles.exportTrailer')}
              className="exportContainer"
              onClick={() => exportTrailer()}
            />
          </div>
        </div>
        <div className="importNew">
          <Button
            component={LinkDom}
            variant="body2"
            to={pageUrls.addTrailer}
            className="linkStyle"
            onClick={() => {
              history.push(pageUrls.addTrailer);
              closeModal();
            }}
            label={i18n.t('vehicles.addTrailer')}
          ></Button>
          <div className="importWrap">
            <div className="importsection">
              <Import onClick={(e) => importTrailers(e)} asBinary importVehicle={i18n.t('vehicles.importTra')} id="importTra" />
            </div>
            <Link
              variant="body2"
              onClick={() => {
                let url = beBaseUrl + '/trailer/csvtemplate' + '?token=' + logBook?.documentToken;

                document.getElementById('importVehicleTemplateFrame').src = url;
                closeModalTemplate();
              }}
            >
              <Icon src={mediaUrls?.excel} tooltip={i18n.t('vehicles.importTrailerTemplate')} />
            </Link>
          </div>
        </div>
      </Styled.ImpExpWrapper>
      <div className="breadcrumbClass">
        <Breadcrumb filters={filters} />
      </div>
      <Modal
        open={openModalRefImport}
        setOpen={setModalRefImport}
        data={ModalListObjectImport}
        isUserProfile
        optionListPopup
        right={7}
      />
      <Modal
        open={openModalRefTemplate}
        setOpen={setModalRefTemplate}
        data={ModalListObjectTemplate}
        isUserProfile
        optionListPopup
        width={'200px'}
        right={10}
      />

      <Modal open={openModal} setOpen={setOpenModal} data={ModalListObject} isUserProfile optionListPopup top={166} right={13} />
      <iframe id="importVehicleTemplateFrame" style={{ display: 'none' }}></iframe>
    </Styled.TopWrapper>
  );
};
export default TopActions;
